module.exports = __webpack_public_path__ + "2ec1f6ce5a7a93ff72f41297e8d06a21.jpg";